import { render, staticRenderFns } from "./CRUDGrupos.vue?vue&type=template&id=1e376c59&"
import script from "./CRUDGrupos.vue?vue&type=script&lang=js&"
export * from "./CRUDGrupos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports